import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import {  makeByVehicleType,  carModels, containers, initialForm, searchClient, searchConsignee,searchTransportCompany, searchDestination, searchPortLoading, searchShippingLine, searchMake, searchModel, searchVehicleType, searchBooking, searchReturnTerminal, searchPickupTerminal, searchConsigneeDock, searchBroker } from "../actions/formAction";

const initialState = {
    loading: 'idle',
    hasError: false,
    errorMessage: '',
    data: {
        colorList: [],
        fuelTypeList: [],
        portList: [],
        statusList: [],
        vehicleTypeList: [],
        makeList: [],
        warehouseList: [],
        clientList: [],
        transportCompanyList: [],
     
    },
    makeByVehicleType: {
        isLoading: 'idle',
       makeList: [],
    },
    carModels: {
        models: [],
        isLoadingCarModels: 'idle',
    },
    container: [],
    booking: {},
    consignee: {},
    consigneeDock: {},
    client:{},
    portLoading: {},
    transportCompany: {},
    destination: {},
    make: {},
    vehicleType: {},
    pickupTerminal: {},
    returnTerminal: {},
    shippingLine: {},
    broker: {},
    isLoadingTransportCompanyData: 'idle',
    isLoadingContainerData: 'idle',
    isLoadingBookingData: 'idle',
    isLoadingConsigneeData: 'idle',
    isLoadingConsigneeDockData: 'idle',
    isLoadingClientData: 'idle',
    isLoadingDestinationData: 'idle',
    isLoadingPortData: 'idle',
    isLoadingShippingLineData: 'idle',
    isLoadingMakeData:"idle",
    isLoadingVehicleTypeData: 'idle',
    isLoadingPickupTerminalData: 'idle',
    isLoadingReturnTerminalData: 'idle',
    isLoadingBrokerData: 'idle',


}

const formInitialSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        resetState: () => {

            return initialState;
        },
        addDeletedObject: (state, action) => {


            const { name, object } = action.payload


            state.data[name].push(object);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(initialForm.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
            })
            .addCase(initialForm.fulfilled, (state, action) => {
                const response = action.payload;
                state.loading = 'succeeded';
                state.hasError = false;
                state.data = response

            })
            .addCase(initialForm.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
            })
            .addCase(makeByVehicleType.pending, (state) => {
                state.makeByVehicleType.isLoading = 'pending';
                state.hasError = false
               state.makeList = []
            })
            .addCase(makeByVehicleType.fulfilled, (state, action) => {
                const response = action.payload;
                state.makeByVehicleType = {
                    isLoading: 'succeeded',
                    hasError: false,
                    makeList:response
                   
                }

            })
            .addCase(makeByVehicleType.rejected, (state, action) => {
                state.makeByVehicleType.isLoading = 'failed';
                state.hasError = true;
                state.makeList = [];
                state.errorMessage = action.payload
            })
            //
            .addCase(carModels.pending, (state) => {
                state.carModels.isLoadingCarModels = 'pending';
                state.hasError = false
            })
            .addCase(carModels.fulfilled, (state, action) => {
                const response = action.payload;
                state.carModels = {
                    isLoadingCarModels: 'succeeded',
                    models: response,
                };
                state.hasError = false


            })
            .addCase(carModels.rejected, (state, action) => {
                state.carModels.isLoadingCarModels = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })
            //
            .addCase(containers.pending, (state) => {
                state.isLoadingContainerData = 'pending';
                state.hasError = false
            })
            .addCase(containers.fulfilled, (state, action) => {
                const response = action.payload;
                state.container = response
                state.hasError = false
                state.isLoadingContainerData = 'succeeded';
            })
            .addCase(containers.rejected, (state, action) => {
                state.isLoadingContainerData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })






            .addCase(searchConsignee.pending, (state) => {
                state.isLoadingConsigneeData = 'pending';
                state.hasError = false
            })
            .addCase(searchConsignee.fulfilled, (state, action) => {
                const { response ,cacheKey} = action.payload;
                state.consignee[cacheKey] = response
                state.hasError = false
                state.isLoadingConsigneeData = 'succeeded';
            })
            .addCase(searchConsignee.rejected, (state, action) => {
                state.isLoadingConsigneeData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
                

            })








             .addCase(searchConsigneeDock.pending, (state) => {
                state.isLoadingConsigneeDockData = 'pending';
                state.hasError = false
            })
            .addCase(searchConsigneeDock.fulfilled, (state, action) => {

                const  response  = action.payload;
                state.consigneeDock["{}"] = response
                state.hasError = false
                state.isLoadingConsigneeDockData = 'succeeded';
            })
            .addCase(searchConsigneeDock.rejected, (state, action) => {
                state.isLoadingConsigneeDockData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
                

            })






            .addCase(searchClient.pending, (state) => {
                state.isLoadingClientData = 'pending';
                state.hasError = false
            })
            .addCase(searchClient.fulfilled, (state, action) => {
                
                const { response ,cacheKey} = action.payload;

                state.client[cacheKey] = response

                state.hasError = false
                state.isLoadingClientData = 'succeeded';
            })
            .addCase(searchClient.rejected, (state, action) => {
                state.isLoadingClientData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })

             .addCase(searchTransportCompany.pending, (state) => {
                state.isLoadingTransportCompanyData = 'pending';
                state.hasError = false
            })
            .addCase(searchTransportCompany.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.transportCompany["{}"] = response
                state.hasError = false
                state.isLoadingTransportCompanyData = 'succeeded';
            })
            .addCase(searchTransportCompany.rejected, (state, action) => {
                state.isLoadingTransportCompanyData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })
            .addCase(searchDestination.pending, (state) => {
                state.isLoadingDestinationData = 'pending';
                state.hasError = false
            })
            .addCase(searchDestination.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.destination["{}"] = response
                state.hasError = false
                state.isLoadingDestinationData = 'succeeded';
            })
            .addCase(searchDestination.rejected, (state, action) => {
                state.isLoadingDestinationData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })



            .addCase(searchPortLoading.pending, (state) => {
                state.isLoadingPortData = 'pending';
                state.hasError = false
            })
            .addCase(searchPortLoading.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.portLoading["{}"] = response
                state.hasError = false
                state.isLoadingPortData = 'succeeded';
            })
            .addCase(searchPortLoading.rejected, (state, action) => {
                state.isLoadingPortData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })






            .addCase(searchShippingLine.pending, (state) => {
                state.isLoadingShippingLineData = 'pending';
                state.hasError = false
            })
            .addCase(searchShippingLine.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.shippingLine["{}"] = response
                state.hasError = false
                state.isLoadingShippingLineData = 'succeeded';
            })
            .addCase(searchShippingLine.rejected, (state, action) => {
                state.isLoadingShippingLineData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })



            .addCase(searchMake.pending, (state) => {
                state.isLoadingMakeData = 'pending';
                state.hasError = false
            })
            .addCase(searchMake.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.make["{}"] = response
                state.hasError = false
                state.isLoadingMakeData = 'succeeded';
            })
            .addCase(searchMake.rejected, (state, action) => {
                state.isLoadingMakeData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })




             .addCase(searchModel.pending, (state) => {
                state.isLoadingModelData = 'pending';
                state.hasError = false
            })
            .addCase(searchModel.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.model["{}"] = response
                state.hasError = false
                state.isLoadingModelData = 'succeeded';
            })
            .addCase(searchModel.rejected, (state, action) => {
                state.isLoadingModelData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })





            
             .addCase(searchVehicleType.pending, (state) => {
                state.isLoadingVehicleTypeData = 'pending';
                state.hasError = false
            })
            .addCase(searchVehicleType.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.vehicleType["{}"] = response
                state.hasError = false
                state.isLoadingVehicleTypeData = 'succeeded';
            })
            .addCase(searchVehicleType.rejected, (state, action) => {
                state.isLoadingVehicleTypeData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })


            
             .addCase(searchBooking.pending, (state) => {
                state.isLoadingBookingData = 'pending';
                state.hasError = false
            })
            .addCase(searchBooking.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.booking["{}"] = response
                state.hasError = false
                state.isLoadingBookingData = 'succeeded';
            })
            .addCase(searchBooking.rejected, (state, action) => {
                state.isLoadingBookingData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })
            .addCase(searchPickupTerminal.pending, (state) => {
                state.isLoadingPickupTerminalData = 'pending';
                state.hasError = false
            })
            .addCase(searchPickupTerminal.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.pickupTerminal["{}"] = response
                state.hasError = false
                state.isLoadingPickupTerminalData = 'succeeded';
            })
            .addCase(searchPickupTerminal.rejected, (state, action) => {
                state.isLoadingPickupTerminalData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })
            .addCase(searchReturnTerminal.pending, (state) => {
                state.isLoadingReturnTerminalData = 'pending';
                state.hasError = false
            }   )
            .addCase(searchReturnTerminal.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.returnTerminal["{}"] = response
                state.hasError = false
                state.isLoadingReturnTerminalData = 'succeeded';
            })
            .addCase(searchReturnTerminal.rejected, (state, action) => {
                state.isLoadingReturnTerminalData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })







             .addCase(searchBroker.pending, (state) => {
                state.isLoadingBrokerData = 'pending';
                state.hasError = false
            }   )
            .addCase(searchBroker.fulfilled, (state, action) => {
                const  response  = action.payload;
                state.broker["{}"] = response
                state.hasError = false
                state.isLoadingBrokerData = 'succeeded';
            })
            .addCase(searchBroker.rejected, (state, action) => {
                state.isLoadingBrokerData = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload

            })



    }

});
export const { resetState, addDeletedObject } = formInitialSlice.actions;

export default formInitialSlice.reducer;
